import { render, staticRenderFns } from "./jd-button.vue?vue&type=template&id=732bf881&scoped=true"
import script from "./jd-button.vue?vue&type=script&lang=js"
export * from "./jd-button.vue?vue&type=script&lang=js"
import style0 from "./jd-button.vue?vue&type=style&index=0&id=732bf881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bf881",
  null
  
)

export default component.exports